export const CONTENTS_HOME = 'contentHome';
export const CHAPTER_VIEWER = 'chapterViewer';
export const COMMENT_HISTORY = 'commentHistory';

export const LCS_TYPES = {
	CONTENTS_HOME,
	CHAPTER_VIEWER,
	COMMENT_HISTORY
};